module.exports = __webpack_public_path__ + "a4f93605d588ae4f1523298f16c5fc3e.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-forbes.png
// module id = 632
// module chunks = 0